import { spacingSizes } from '@/types/spacing';
import { VerticalSpacer } from './VerticalSpacer';
import register from './register';

register(VerticalSpacer, {
	sizes: [{ label: 'unset', value: 'unset' } as const, ...spacingSizes],
	defaultDesktopSize: 'var(--spacing-md)',
	defaultTabletSize: 'unset',
	defaultMobileSize: 'unset',
});
